import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import RichText, { SecondaryRenderer } from '../design-system/RichText';
import { HeadingArticle } from '../design-system/Headings';
import {
  Form, Field, Submit,
} from '../design-system/Forms';
import { Divider } from '../design-system/Dividers';
import { LinkButton } from '../design-system/Buttons';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

import staticPageType from '../proptypes/static-page';
import phrasesType from '../proptypes/phrases';
import formType from '../proptypes/forms';

const SignUpPage = ({
  content: {
    heading, body, sidePanel,
  },
  signUpForm,
  phrases: { form: formPhrases, signIn, ...phrases },
  signInPath,
  inputFieldValues,
  spychologySignUpPath,
}) => {
  const ticketHint = (
    <>
      {phrases.noTicket}
      &nbsp;
      <a href={spychologySignUpPath}>{phrases.joinSpychology}</a>
    </>
  );

  return (
    <PageWrapper bgDark>
      <RadarHeroPageSection center={false}>
        <div className="row">
          <div className="col-12 col-lg-6">
            <HeadingArticle el="h1">{heading}</HeadingArticle>
          </div>
        </div>
      </RadarHeroPageSection>
      <PageSection>
        <div className="row">
          <div className="col-12 col-lg-6">
            <RichText
              content={body}
              paragraphRenderer={SecondaryRenderer}
            />
            <Divider myLg />
            <Form {...signUpForm} inline>
              <Field label={formPhrases.fullName} name="full_name" required defaultValue={inputFieldValues?.fullName} />
              <Field label={formPhrases.email} name="email" type="email" required defaultValue={inputFieldValues?.email} />
              <Field label={formPhrases.password} name="password" type="password" required />
              <Field
                label={formPhrases.scanCode}
                name="scan_code"
                maxLength={10}
                required
                defaultValue={inputFieldValues.scanCode}
                hint={ticketHint}
              />
              <Field label={formPhrases.newsletter} name="newsletter" type="checkbox" />
              <Submit>{formPhrases.submitWithTicket}</Submit>
            </Form>
            <LinkButton w100 secondary href={signInPath}>{signIn}</LinkButton>
          </div>
          <div className="col-lg-1" />
          <div className="col-12 col-lg-5">
            <RichText content={sidePanel} className="ss_sidepanel" />
          </div>
        </div>
      </PageSection>
    </PageWrapper>
  );
};

SignUpPage.defaultProps = {
  inputFieldValues: {},
};

SignUpPage.propTypes = {
  content: staticPageType.isRequired,
  phrases: phrasesType.isRequired,
  signUpForm: formType.isRequired,
  inputFieldValues: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
    ]),
  ),
  signInPath: PropTypes.string.isRequired,
  spychologySignUpPath: PropTypes.string.isRequired,
};

export default hot(SignUpPage);
